import { create } from "zustand";

interface PatientStore {
  patientId: number | null;
  setPatientId: (patientId: number | null) => void;
}

export const patientStore = create<PatientStore>()((set) => ({
  patientId: null,
  setPatientId: (patientId) => set({ patientId }),
}));

export function usePatientId(): [
  patientId: number | null,
  setPatientId: (patientId: number | null) => void,
] {
  const patientId = patientStore((state) => state.patientId);
  const setPatientId = patientStore((state) => state.setPatientId);
  return [patientId, setPatientId];
}
